<template>
  <v-form ref="expenseForm" v-model="valid" :lazy-validation="lazy">
    <v-row dense>
      <v-col cols="12" xs="12" sm="3" md="3">
        <v-autocomplete
          autocomplete="off"
          name="expenseCategory"
          outlined
          dense
          :rules="inputRules"
          v-model="record.CategoryId"
          :items="expenseAccounts"
          label="Category"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" sm="3" md="3">
        <v-text-field
          autocomplete="off"
          :rules="inputRules"
          name="expenseAmountInput"
          dense
          outlined
          label="Amount"
          v-model="record.Amount"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-autocomplete
          :rules="inputRules"
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="record.AccountId"
          :items="accounts"
          label="Account"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" sm="3" md="3">
        <DatePicker v-if="canBackDate == 'Y'" @date="setDate" :myDate="date" :title="`Date`" ref="dateRef"></DatePicker>
        <span v-else class="style-16">Date: {{ date }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12">
        <v-textarea
          name="expenseDescription"
          outlined
          rows="2"
          label="Description"
          v-model="record.narration"
        ></v-textarea>
      </v-col>

      <v-col cols="4">
        <v-autocomplete
          autocomplete="off"
          dense
          outlined
          v-model="record.StaffId"
          :items="employees"
          label="Staff"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="primary"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Save Expense
        </v-btn>

        <v-btn v-else color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>

<script>
export default {
  name: "AccountsIndex",
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  computed: {
    canBackDate() {
      return localStorage.getItem("canBackDate");
    },
  },
  data: () => ({
    lazy: false,
    valid: false,
    accountId: null,
    inputRules: [v => !!v || "Required"],
    requiredRules: [
      v => !!v || "Required"
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    record: {},
    accounts: [],
    expenseAccounts: [],
    employees: [],
    loader: false,
    date: new Date().toISOString().substr(0, 10)
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.date = date;
    },
    async sendData() {
      if (!this.$refs.expenseForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      this.record.Amount = parseFloat(this.record.Amount);
      this.record.DocDate = this.date;
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    expAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/expenditure-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.expenseAccounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.employees = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([this.getAccounts(), this.expAccounts(), this.getUsers()]);
  }
};
</script>
